import {isRolePermission} from '@core/layouts/utils'
import {useSelector} from 'react-redux'
import {Navigate} from 'react-router-dom'

const ProtectedRoute = ({permissions = '', children}) => {
  const {userData} = useSelector((state) => state.auth)
  const hasModulePermission = isRolePermission(permissions, userData)
  if (!hasModulePermission) {
    return <Navigate to="/" />
  }

  return children
}

export default ProtectedRoute
